namespace Ir.Components.Workbook.Settings.DashboardSettings {
    interface IViewModel {
        config: WorkbookConfig;
        activeTab: KnockoutObservable<WorkbookTab>;

        backgroundColorParams: Ir.Components.Workbook.Settings.Items.ColorSetting.IColorSettingParams;
        widgetDefaultBackgroundColorParams: Ir.Components.Workbook.Settings.Items.ColorSetting.IColorSettingParams;

        popoverConfig: DevExpress.ui.dxPopover.Properties;
        popoverComponent: DevExpress.ui.dxPopover;
    }

    interface IParams {
        config: WorkbookConfig;
        callback: (component: DevExpress.ui.dxPopover) => void;
        target: any;
    }

    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        let self = this;
        this.config = params.config as WorkbookConfig;
        this.activeTab = this.config.activeTab;       

        this.backgroundColorParams = {
            label: "Background Color",
            value: ko.pureComputed({
                read: function (this: KnockoutObservable<WorkbookTab>) {
                    return this().dashboard?.appearance?.backgroundColor();
                },
                write: function (this: KnockoutObservable<WorkbookTab>, value: string) {
                    this().dashboard.appearance.backgroundColor(value);
                },
            }, this.activeTab),
            appendTo: "parent"
        };

        this.widgetDefaultBackgroundColorParams = {
            label: "Widget Default Background Color",
            value: ko.pureComputed({
                read: function (this: KnockoutObservable<WorkbookTab>) {
                    return this().dashboard?.appearance?.widgetDefaultBackgroundColor();
                },
                write: function (this: KnockoutObservable<WorkbookTab>, value: string) {
                    this().dashboard.appearance.widgetDefaultBackgroundColor(value);
                },
            }, this.activeTab),
            appendTo: "parent"
        };

        this.popoverConfig = {
            title: "Dashboard Settings",
            showTitle: true,
            width: 300,
            target: params.target,
            onInitialized(e) {
                self.popoverComponent = e.component;
                if (params.callback) {
                    params.callback(e.component);
                }
            }
        };
    }

    let popoverComponent: DevExpress.ui.dxPopover;
    export function show(target) {
        if (popoverComponent == null) {
            let $popup = $(`<dashboard-settings params="config: $data.config, callback: $data.callback, target: $data.target"></dashboard-settings>`);
            $popup.appendTo('body');
            ko.applyBindings({
                config: workbook.workbookConfig,
                callback(component: DevExpress.ui.dxPopover) {
                    popoverComponent = component;
                    popoverComponent.show();
                },
                target: target
            }, $popup.get(0));
        }
        else {
            popoverComponent.show();
        }
    }
}